import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import { PaymentPlanEnum } from 'src/configs/APISchemas/BindPolicy';
import { PaymentPlanFieldOptionLabel } from 'src/pages/payment-msi/PaymentMsiV2/components/PaymentPlanFieldOptionLabel';
import { EventFor } from 'src/types';
import { PaymentPlanOption } from '../utils';

interface PaymentOptionFieldProps {
  isActive: boolean;
}
const PaymentOptionField = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<PaymentOptionFieldProps>(({ theme, isActive }) => {
  return {
    borderRadius: '20px',
    background: isActive ? theme.palette.primary.main : '#fff',
    boxShadow: isActive ? 'none' : '4px 16px 32px 0px rgba(29, 29, 29, 0.08)',
    transition: 'background 0.1s',
    '&:hover': {
      background: isActive
        ? theme.palette.primary.main
        : theme.palette.background.secondary,
    },
  };
});

const PaymentOptionRadio = styled(Radio)(({ theme }) => {
  return {
    '&.Mui-checked': {
      color: theme.palette.primary.contrastText,
    },
  };
});

const paymentPlanFieldStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  formControlLabel: {
    columnGap: '8px',
    padding: '32px 23px',
    width: '100%',
    boxSizing: 'border-box',
    marginRight: 0,
    marginLeft: 0,
  },
  formControlTypography: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
};

interface PaymentPlanFieldProps {
  value: PaymentPlanEnum;
  name: string;
  onChange: (value: PaymentPlanEnum) => void;
  paymentOptions: PaymentPlanOption[];
}

export function PaymentPlanField({
  onChange,
  name,
  paymentOptions,
  value,
}: PaymentPlanFieldProps) {
  function handleChange(event: EventFor<'input', 'onChange'>) {
    const eventValue = event.target.value as PaymentPlanEnum;
    onChange(eventValue);
  }

  return (
    <RadioGroup
      sx={paymentPlanFieldStyles.root}
      onChange={handleChange}
      name={name}
      value={value}
    >
      {paymentOptions.map((option) => {
        const isActive = option.value === value;

        return (
          <PaymentOptionField isActive={isActive} key={option.value}>
            <FormControlLabel
              sx={paymentPlanFieldStyles.formControlLabel}
              control={<PaymentOptionRadio />}
              componentsProps={{
                typography: {
                  sx: paymentPlanFieldStyles.formControlTypography,
                },
              }}
              label={
                <PaymentPlanFieldOptionLabel
                  isActive={isActive}
                  option={option}
                />
              }
              value={option.value}
            />
          </PaymentOptionField>
        );
      })}
    </RadioGroup>
  );
}
